import { merge } from 'lodash';
import Button from './Button';
import Backdrop from './Backdrop';

export default function ComponentsOverrides(theme) {
	return merge(Button(theme), Backdrop(theme));
}
